import components from './components.json' with { type: 'json' };
import pages from './pages.json' with { type: 'json' };

export default {
  components,
  pages,
};
